{
  class Carousel {
    constructor(carousel) {
      this.carousel = carousel;
      this.leftButton = carousel.querySelector(".bux-card-carousel__nav--left");
      this.rightButton = carousel.querySelector(".bux-card-carousel__nav--right");
      this.container = carousel.querySelector(".bux-card-carousel__container");
      this.card = this.container.querySelector(".bux-card");

      // Updates navigation buttons when a carousel is created
      this.updateNavigation();

      // Event listeners to update navigation on scroll and window resize
      this.container.addEventListener("scroll", () => {
        this.updateNavigation();
      });
      window.addEventListener("resize", () => {
        this.updateNavigation();
      });

      // Set up navigation button listeners for left and right buttons
      this.setupNavButtonListeners({ button: this.leftButton, direction: -1 });
      this.setupNavButtonListeners({ button: this.rightButton, direction: 1 });
    }

    setupNavButtonListeners({ button, direction }) {
      // Scrolls carousel the carousel 1 card based on button clicked
      const navigate = () => {
        const cardWidthIncludingMargins =
          this.card.offsetWidth +
          parseFloat(window.getComputedStyle(this.card).marginRight);
        this.container.scrollBy({
          top: 0,
          left: direction * cardWidthIncludingMargins,
          behavior: "smooth",
        });
      };

      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        navigate();
      });

      button.parentElement.addEventListener("click", () => {
        navigate();
      });

    }

    // Updates tab indices and button visibility
    updateNavigation() {
      this.updateCardAccessibility();
      this.updateButtonVisibility();
    }

    // Updates tab functionality based on card visibility in carousel
    updateCardAccessibility() {
      const cards = this.container.querySelectorAll(".bux-card");
      const containerWidth = this.container.offsetWidth;
      const containerScroll = this.container.scrollLeft;

      cards.forEach((card) => {
        const cardLeft = card.offsetLeft - containerScroll;
        const cardRight = cardLeft + card.offsetWidth;
        const isCardVisible = (cardLeft >= 0) && (cardRight <= containerWidth);

        if (isCardVisible) {
          card.removeAttribute("aria-hidden");
        } else {
          card.setAttribute("aria-hidden", "true");
        }
        const interactiveElements = card.querySelectorAll("a, button");

        interactiveElements.forEach((el) => {
          if (isCardVisible) {
            el.removeAttribute("tabindex");
          } else {
            el.setAttribute("tabindex", "-1");
          }
        });
      });
    }

    // Updates navigation button visibility based on scroll distance
    updateButtonVisibility() {
      this.leftButton.style.display =
        this.container.scrollLeft > 0 ? "flex" : "none";
      this.rightButton.style.display =
        this.container.scrollWidth -
          this.container.scrollLeft -
          this.container.clientWidth >
        1
          ? "flex"
          : "none";
    }
  }

  const carousels = document.querySelectorAll(".bux-card-carousel");
  carousels.forEach((carouselElement) => new Carousel(carouselElement));
}
